// 支持翻译的语言配置
export const langConfig = {
  Chinese: 'zh-CN',
  Spanish: 'sp-ES',
  German: 'de-DE',
  French: 'fr-FR',
  Portuguese: 'pt-PT',
  Italian: 'it-IT',
  Japanese: 'ja-JP',
  Russian: 'ru-RU',
  Dutch: 'nl-NL',
  Korean: 'ko-KR',
}

// 屏幕宽度
// 参照bootstrap
// 如移动端为 < md
export const screenWidthType = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
}